import { Mapper } from 'src/base/mapper'
import { InvoiceLogsTypeEntity } from 'src/data/entities/invoice.entity'
import { InvoiceLogsTypeModel } from 'src/domain/models/invoice.model'

export class InvoiceLogsMapper extends Mapper<InvoiceLogsTypeEntity, InvoiceLogsTypeModel> {
	mapFrom(param: InvoiceLogsTypeEntity): InvoiceLogsTypeModel {
		return this.resultData(param)
	}

	mapTo(param: InvoiceLogsTypeModel): InvoiceLogsTypeEntity {
		return this.resultData(param)
	}

	resultData(param: InvoiceLogsTypeEntity | InvoiceLogsTypeModel) {
		return {
			tag: param.tag,
			errorMessage: param.errorMessage,
			dateLog: param.dateLog,
		}
	}
}
